import { Grid, Image } from "antd";
import "swiper/css";
import "swiper/css/effect-fade";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { BannerResponse } from "../../../../hooks/data";
import "./style";
import styles from "./styleModule";

const PromotionBannerContainer: React.FC<{
  banners: BannerResponse[];
  loadingBanner: boolean;
  visibleBanner: BannerResponse[];
  autoplayDelay: number;
  handleOpenUrl: (url: string | null | undefined) => void;
  renderLoading: () => React.ReactNode;
}> = ({
  banners,
  loadingBanner,
  visibleBanner,
  autoplayDelay,
  handleOpenUrl,
  renderLoading,
}) => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const getMarginTop = () => {
    if (screens.md) return "290px";
    if (screens.xs) return "240px";
    return "350px"; // Default for xs or smaller
  };

  const getBannerSize = () => {
    if (screens.md) return { width: 355, height: 200 };
    return { width: 343, height: 192 }; // Default for xs or smaller
  };

  const getWidth = () => {
    if (screens.xxl) return "calc(100% - 480px)";
    if (screens.md) return "calc(100% - 80px)";
    return "calc(100% - 32px)";
  };

  const getSlidesPerView = () => {
    if (screens.xl) return 3;
    if (screens.sm) return 2;
    return 1;
  };

  return (
    <div
      className={`${styles.bannerContainer} promo-banner`}
      style={{ marginTop: getMarginTop(), width: getWidth() }}
    >
      {!banners || loadingBanner ? (
        renderLoading()
      ) : (
        <Swiper
          pagination={
            screens.xs ? { dynamicBullets: true, clickable: true } : undefined
          }
          modules={[Autoplay, Pagination]}
          slidesPerView={getSlidesPerView()}
          // centeredSlides={true}
          loop={true}
          autoplay={{ delay: autoplayDelay, disableOnInteraction: false }}
          spaceBetween={21}
          slideToClickedSlide={true}
          style={{ padding: 0 }}
        >
          {visibleBanner.map((banner: BannerResponse, index: number) => {
            return (
              <SwiperSlide
                key={`banner_${index}`}
                style={{ ...getBannerSize() }}
              >
                <Image
                  onClick={() => handleOpenUrl(banner?.link_url)}
                  width={"100%"}
                  height={"100%"}
                  preview={false}
                  src={banner.image_url}
                  className={styles.bannerImage}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      )}
    </div>
  );
};

export default PromotionBannerContainer;
